export default "__VITE_ASSET__Dvq$D0us__"